import { BorrowerOtherIncome } from '../../../shared/models/borrower-other-income.model';
import { ModelValidator } from '../../../shared/validation/model-validator';

import { ClientJourneyValidationMetadata } from '../../../shared/validation/client-journey-validation-metadata';

export enum OtherIncomeValidationRules {
  IncomeAmount = 'amount',
  IncomeStartDate = 'start',
}

export class BorrowerOtherIncomeValidator extends ModelValidator<
  BorrowerOtherIncome,
  ClientJourneyValidationMetadata
> {
  constructor(borrowerOtherIncome: BorrowerOtherIncome) {
    super(borrowerOtherIncome);

    let navigationMetadata = <ClientJourneyValidationMetadata>{
      blocksNavigation: false,
      showInMenu: true,
    };

    // Income amount
    this.ruleFor(
      income => income.amount,
      OtherIncomeValidationRules.IncomeAmount,
      navigationMetadata,
    ).must(amount => !!amount);

    // Income amount
    this.ruleFor(
      income => income.start,
      OtherIncomeValidationRules.IncomeStartDate,
      navigationMetadata,
    ).must(startDate => startDate != null);
  }
}
